import { format } from 'date-fns'
import css from './timeDropdown.module.css'
import FadeInPanel from '@/shared/Animated/FadeInPanel'

interface IProps {
  time: string | null
  range?: boolean
  onChange: (time: string) => void
  toggleDropdown: () => void
  open: boolean
  type?: 'default' | 'itemCalendar'
}

const TimeDropdown = ({ type = 'default', time = '00:00:00', onChange, toggleDropdown, open }: IProps) => {
  const updateSelectedTime = (value: string, type: 'hour' | 'minute' | 'second') => {
    const [hour, minute, second] = time?.split(':') ?? ['00', '00', '00']
    const newTime = {
      hour: `${value}:${minute}:${second}`,
      minute: `${hour}:${value}:${second}`,
      second: `${hour}:${minute}:${value}`,
    }[type]
    onChange(newTime)
  }

  const renderTimeColumn = (type: 'hour' | 'minute' | 'second') => {
    const maxValue = type === 'hour' ? 24 : 60
    const values = Array.from({ length: maxValue }, (_, i) => String(i).padStart(2, '0'))
    const selectedValue = time?.split(':')?.[{ hour: 0, minute: 1, second: 2 }[type]] || '00'

    return (
      <div className={css.timeColumn} key={type}>
        {values.map((value) => (
          <div
            key={`${type}-${value}`}
            className={`${css.timeOption} ${value === selectedValue ? css.selectedOption : ''}`}
            onClick={() => updateSelectedTime(value, type)}
          >
            {value}
          </div>
        ))}
      </div>
    )
  }

  const handleNowClick = () => {
    const currentTime = format(new Date(), 'HH:mm:ss')
    onChange(currentTime)
  }

  return (
    <div
      className={`${css.dropdown} ${type === 'itemCalendar' ? css.dropdownCalendar : ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      <FadeInPanel open={open || type === 'itemCalendar'}>
        <div className={css.timeColumns}>
          {['hour', 'minute', 'second'].map((type) => renderTimeColumn(type as 'hour' | 'minute' | 'second'))}
        </div>
        {type === 'default' && (
          <div className={css.actions}>
            <button className={css.nowButton} onClick={handleNowClick}>
              Now
            </button>
            <button className={css.okButton} onClick={toggleDropdown}>
              OK
            </button>
          </div>
        )}
      </FadeInPanel>
    </div>
  )
}

export default TimeDropdown
